.button {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: var(--space-2);
	min-height: 44px;
	padding: var(--space-3) var(--space-5);
	border: none;
	border-radius: var(--radius-md);
	font: inherit;
	font-weight: 600;
	cursor: pointer;
	transition: transform 0.1s ease;
}

.button:active:not(:disabled) {
	transform: translateY(1px);
}

.button:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

.logo {
	width: 1.1em;
	height: 1.1em;
	flex: none;
	/* The glyph sits low in its box; lift it level with the text. */
	margin-top: -0.15em;
}

/* Apple's rules: black on light backgrounds, white on dark ones. */
.apple {
	background: #000;
	color: #fff;
}

@media (prefers-color-scheme: dark) {
	.apple {
		background: #fff;
		color: #000;
	}
}
